var WarmupQuestions = require("lib/academic/WarmupQuestions");
var TopicQuestion = require("components/writing/quizzes/warmups/TopicQuestion");

class FictionOrganizationQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	isPictureBook() {
		if (this.props.answers[TopicQuestion.STEM]) {
			return this.props.answers[TopicQuestion.STEM][TopicQuestion.TEXT_TYPE] == "picture book";
		}
	}

	getDisplayStatus() {
		var answers = this.props.answers[FictionOrganizationQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [NUM_PAGES_STAGE];
		}
		
		if (!answers[NUM_PAGES] || answers[NUM_PAGES] < 1 || (this.isPictureBook() && !answers[SEL_PIECE_NUMBER])) {
			return [NUM_PAGES_STAGE];
		}

		if (!this.isPictureBook() && (!answers[NUM_PIECES] || !answers[PIECE_TYPE] || !answers[SEL_PIECE_NUMBER] || answers[NUM_PIECES] < 1)) {
			return [ORG_STRUCTURE_STAGE];
		}

		if (this.props.level == "1") {
			if (!answers[SEL_PIECE_DESCRIPTION]) {
				return [RANDOM_PIECE_STAGE];
			} else {
				return [RANDOM_PIECE_STAGE, true];
			}
		}

		if (!answers[SEL_PIECE_TIMING] || !answers[SEL_PIECE_CHAR] || !answers[SEL_PIECE_ACTION]) {
			return [RANDOM_PIECE_STAGE];
		} else if (this.props.level == "2") {
			return [RANDOM_PIECE_STAGE, true];
		}

		if (!answers[SEL_PIECE_STORY_PART]) {
			return [RANDOM_PIECE_PART_STAGE];
		} else {
			return [RANDOM_PIECE_PART_STAGE, true];
		}
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var numPagesDisplay = (
			<div>
				{ this.props.getTextF("label1", NUM_PAGES_STAGE) }
				{ this.props.renderInputF(NUM_PAGES, null, "number") }
				{ this.props.getTextF("label2", NUM_PAGES_STAGE) }.
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0 && !this.isPictureBook()) {
			var orgStructureDisplay = (
				<div>
					{ this.props.getTextF("label1", ORG_STRUCTURE_STAGE) }
					{ this.props.renderInputF(NUM_PIECES, null, "number") }
					{ this.props.renderDropdownF("choices1", ORG_STRUCTURE_STAGE, PIECE_TYPE, [NUM_PAGES, NUM_PIECES, SEL_PIECE_NUMBER]) }.
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1) {
			var answers = this.props.answers[FictionOrganizationQuestion.STEM];
			var replacementsHash = {};
			replacementsHash[WarmupQuestions.ORG_PIECE] = this.isPictureBook() ? "page" : (answers[PIECE_TYPE]).slice(0, -1);
			replacementsHash[WarmupQuestions.ORG_PIECE_NUMBER] = answers[SEL_PIECE_NUMBER];

			if (this.props.level == "1") {
				var randomPieceInputs = this.props.renderInputF(SEL_PIECE_DESCRIPTION);
			} else {
				var randomPieceInputs = (
					<span>
						{ this.props.renderDropdownF("choices1", RANDOM_PIECE_STAGE, SEL_PIECE_TIMING) }
						{ this.props.getTextF("label2", RANDOM_PIECE_STAGE) }
						<br />
						<div className="inputGroup">
							{ this.props.renderInputF(SEL_PIECE_CHAR) }
							<br />
							<span className="subtext">
								{ this.props.getTextF("label3", RANDOM_PIECE_STAGE) }
							</span>
						</div>
						<div className="inputGroup">
							{ this.props.renderInputF(SEL_PIECE_ACTION) }
							<br />
							<span className="subtext">
								{ this.props.getTextF("label4", RANDOM_PIECE_STAGE) }
							</span>
						</div>
					</span>
				);
			}
			var randomPieceDisplay = (
				<div>
					{ $wr.capitalize(this.props.getTextF("label1", RANDOM_PIECE_STAGE, replacementsHash)) }
					{ randomPieceInputs }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 2) {
			var randomPiecePartDisplay = (
				<div>
					{ $wr.capitalize(this.props.getTextF("label1", RANDOM_PIECE_PART_STAGE, replacementsHash)) }
					{ this.props.renderDropdownF("choices1", RANDOM_PIECE_PART_STAGE, SEL_PIECE_STORY_PART) }.
				</div>
			);
		}

		return (
			<div>
				{ numPagesDisplay }
				{ orgStructureDisplay }
				{ randomPieceDisplay }
				{ randomPiecePartDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}

	componentDidUpdate(oldProps) {
		var oldAnswers = oldProps.answers[FictionOrganizationQuestion.STEM];
		var newAnswers = this.props.answers[FictionOrganizationQuestion.STEM];
		if (oldAnswers && newAnswers) {
			if (this.isPictureBook()) {
				var optionKey = NUM_PAGES;
			} else {
				var optionKey = NUM_PIECES;
			}

			if (newAnswers[optionKey] && (oldAnswers[optionKey] != newAnswers[optionKey])) {
				var options = [];
				for (var i = 1; i <= parseInt(newAnswers[optionKey]); i++) {
					options.push(i.toString());
				}

				this.props.pickRandomOptionF(SEL_PIECE_NUMBER, options);
			}
		}
	}
}

FictionOrganizationQuestion.STEM = "forg";

// stages
var NUM_PAGES_STAGE = "numpages";
var ORG_STRUCTURE_STAGE = "orgstructure";
var RANDOM_PIECE_STAGE = "randompiece";
var RANDOM_PIECE_PART_STAGE = "randompiecepart";

var STAGES = [
	NUM_PAGES_STAGE, ORG_STRUCTURE_STAGE, RANDOM_PIECE_STAGE, RANDOM_PIECE_PART_STAGE
];

// answer keys
var NUM_PAGES = "num_pages";
var NUM_PIECES = "num_pieces";
var PIECE_TYPE = "piece_type";
var SEL_PIECE_NUMBER = "selected_piece_number";
var SEL_PIECE_DESCRIPTION = "selected_piece_description";
var SEL_PIECE_TIMING = "selected_piece_timing";
var SEL_PIECE_CHAR = "selected_piece_character";
var SEL_PIECE_ACTION = "selected_piece_action";
var SEL_PIECE_STORY_PART = "selected_piece_story_part";

FictionOrganizationQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
	pickRandomOptionF: PropTypes.func.isRequired,
});

module.exports = FictionOrganizationQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/FictionOrganizationQuestion.js